import script from "./ExhibitsCategories.vue?vue&type=script&setup=true&lang=js"
export * from "./ExhibitsCategories.vue?vue&type=script&setup=true&lang=js"

import "./ExhibitsCategories.vue?vue&type=style&index=0&id=2a5180ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a5180ba"]])

export default __exports__